import { baseUrlServer } from "./common";
import { axiosWithRetry } from "./utils/axiosRetry";

export const getClientLogo = async (userId: string) => {
  try {
    const { data } = await axiosWithRetry<{ url?: string }>(
      `${baseUrlServer}/public/client/logo?userUid=${userId}`,
      "get"
    );
    return data?.url ?? "";
  } catch (e) {
    return "";
  }
};

export const getClientLogoByClientId = async (clientId: string) => {
  try {
    const logoUrl = `https://firebasestorage.googleapis.com/v0/b/${import.meta.env.VITE_APP_STORAGE_BUCKET}/o/public%2Flogos%2F${clientId}?alt=media`;
    return logoUrl;
  } catch (e) {
    return "";
  }
};
